import { ref } from 'vue'
import { createSharedComposable } from '@vueuse/core'
import analytics from '@/utils/analytics'
import { openSupport } from '@/utils/support'

export default createSharedComposable(() => {
  const showKeyboardShortcutsModal = ref(false)

  const openShortcutsModal = () => {
    showKeyboardShortcutsModal.value = true
    analytics.navbarEvent('Clicked navbar popup item', 'Keyboard shortcuts')
  }

  const toggleShortcutsModal = () => {
    showKeyboardShortcutsModal.value = !showKeyboardShortcutsModal.value
    analytics.shortcutUsed('Toggle shortcut modal')
  }

  const openSupportChat = () => {
    openSupport()
    analytics.navbarEvent('Clicked navbar popup item', 'Chat with us')
  }

  return {
    showKeyboardShortcutsModal,
    toggleShortcutsModal,
    openShortcutsModal,
    openSupportChat,
  }
})
